import { render, staticRenderFns } from "./ExerciseSearch.vue?vue&type=template&id=bd353ea0"
import script from "./ExerciseSearch.vue?vue&type=script&lang=js"
export * from "./ExerciseSearch.vue?vue&type=script&lang=js"
import style0 from "./ExerciseSearch.vue?vue&type=style&index=0&id=bd353ea0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports